import { useState } from "react";
import { alpha } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Chip from "@mui/material/Chip";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid2";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import Divider from "@mui/material/Divider";
import Avatar from "@mui/material/Avatar";
import LinearProgress from "@mui/material/LinearProgress";
import { DataGrid } from "@mui/x-data-grid";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PeopleIcon from "@mui/icons-material/People";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AddCardIcon from "@mui/icons-material/AddCard";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import BlockIcon from "@mui/icons-material/Block";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import RefreshIcon from "@mui/icons-material/Refresh";
import AppNavbar from "../components/AppNavbar";
import SideMenu from "../components/SideMenu";
import AppTheme from "../shared-theme/AppTheme";
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from "../theme/customizations";
import PageErrorBoundary from "../components/PageErrorBoundary";
import { useTranslation } from "react-i18next";

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

// --- TEMP DATA ---

const tempCards = [
  { idcards: 1, cardNo: "CARD-0001", cardOwner: "Ahmet Yılmaz", balance: 15000, isActive: 1, periodicRefill: 1, refillAmount: 5000, refillDayOfMont: 1, users_idusers: 1 },
  { idcards: 2, cardNo: "CARD-0002", cardOwner: "Mehmet Demir", balance: 8500, isActive: 1, periodicRefill: 0, refillAmount: 0, refillDayOfMont: 0, users_idusers: 2 },
  { idcards: 3, cardNo: "CARD-0003", cardOwner: "Ayşe Kaya", balance: 22000, isActive: 1, periodicRefill: 1, refillAmount: 10000, refillDayOfMont: 15, users_idusers: 3 },
  { idcards: 4, cardNo: "CARD-0004", cardOwner: "Fatma Çelik", balance: 3200, isActive: 0, periodicRefill: 0, refillAmount: 0, refillDayOfMont: 0, users_idusers: 4 },
  { idcards: 5, cardNo: "CARD-0005", cardOwner: "Ali Öztürk", balance: 45000, isActive: 1, periodicRefill: 1, refillAmount: 15000, refillDayOfMont: 1, users_idusers: 5 },
  { idcards: 6, cardNo: "CARD-0006", cardOwner: "Zeynep Arslan", balance: 0, isActive: 0, periodicRefill: 0, refillAmount: 0, refillDayOfMont: 0, users_idusers: 6 },
  { idcards: 7, cardNo: "CARD-0007", cardOwner: "Burak Şahin", balance: 12500, isActive: 1, periodicRefill: 1, refillAmount: 5000, refillDayOfMont: 1, users_idusers: 7 },
  { idcards: 8, cardNo: "CARD-0008", cardOwner: "Elif Yıldız", balance: 6800, isActive: 1, periodicRefill: 0, refillAmount: 0, refillDayOfMont: 0, users_idusers: 8 },
];

const tempTransactions = [
  { idtransactions: 1, epoch: 1712649600, transactionId: "TXN-20240409-001", amount: 500, productNo: 1, productName: "Çay", transactionType: 1, cards_idcards: 1, cardNo: "CARD-0001", cardOwner: "Ahmet Yılmaz" },
  { idtransactions: 2, epoch: 1712653200, transactionId: "TXN-20240409-002", amount: 1200, productNo: 3, productName: "Kahve", transactionType: 1, cards_idcards: 2, cardNo: "CARD-0002", cardOwner: "Mehmet Demir" },
  { idtransactions: 3, epoch: 1712656800, transactionId: "TXN-20240409-003", amount: 750, productNo: 5, productName: "Su", transactionType: 1, cards_idcards: 1, cardNo: "CARD-0001", cardOwner: "Ahmet Yılmaz" },
  { idtransactions: 4, epoch: 1712660400, transactionId: "TXN-20240409-004", amount: 10000, productNo: 0, productName: "-", transactionType: 2, cards_idcards: 3, cardNo: "CARD-0003", cardOwner: "Ayşe Kaya" },
  { idtransactions: 5, epoch: 1712664000, transactionId: "TXN-20240409-005", amount: 350, productNo: 2, productName: "Soda", transactionType: 1, cards_idcards: 5, cardNo: "CARD-0005", cardOwner: "Ali Öztürk" },
  { idtransactions: 6, epoch: 1712667600, transactionId: "TXN-20240409-006", amount: 900, productNo: 4, productName: "Sıcak Çikolata", transactionType: 1, cards_idcards: 3, cardNo: "CARD-0003", cardOwner: "Ayşe Kaya" },
  { idtransactions: 7, epoch: 1712671200, transactionId: "TXN-20240409-007", amount: 5000, productNo: 0, productName: "-", transactionType: 2, cards_idcards: 1, cardNo: "CARD-0001", cardOwner: "Ahmet Yılmaz" },
  { idtransactions: 8, epoch: 1712674800, transactionId: "TXN-20240409-008", amount: 600, productNo: 1, productName: "Çay", transactionType: 1, cards_idcards: 4, cardNo: "CARD-0004", cardOwner: "Fatma Çelik" },
  { idtransactions: 9, epoch: 1712678400, transactionId: "TXN-20240409-009", amount: 1500, productNo: 6, productName: "Espresso", transactionType: 1, cards_idcards: 7, cardNo: "CARD-0007", cardOwner: "Burak Şahin" },
  { idtransactions: 10, epoch: 1712682000, transactionId: "TXN-20240409-010", amount: 20000, productNo: 0, productName: "-", transactionType: 2, cards_idcards: 5, cardNo: "CARD-0005", cardOwner: "Ali Öztürk" },
];

const tempUsers = [
  { idusers: 1, name: "Ahmet", surname: "Yılmaz", email: "ahmet@example.com", role: 1, phoneNo: "0530 123 45 67", isActive: 1, tenants_idtenants: 1, adminId: 0, cardCount: 1 },
  { idusers: 2, name: "Mehmet", surname: "Demir", email: "mehmet@example.com", role: 2, phoneNo: "0530 987 65 43", isActive: 1, tenants_idtenants: 1, adminId: 1, cardCount: 1 },
  { idusers: 3, name: "Ayşe", surname: "Kaya", email: "ayse@example.com", role: 2, phoneNo: "0532 111 22 33", isActive: 1, tenants_idtenants: 2, adminId: 0, cardCount: 1 },
  { idusers: 4, name: "Fatma", surname: "Çelik", email: "fatma@example.com", role: 2, phoneNo: "0533 444 55 66", isActive: 0, tenants_idtenants: 1, adminId: 1, cardCount: 1 },
  { idusers: 5, name: "Ali", surname: "Öztürk", email: "ali@example.com", role: 1, phoneNo: "0534 777 88 99", isActive: 1, tenants_idtenants: 2, adminId: 0, cardCount: 1 },
  { idusers: 6, name: "Zeynep", surname: "Arslan", email: "zeynep@example.com", role: 2, phoneNo: "0535 000 11 22", isActive: 1, tenants_idtenants: 1, adminId: 1, cardCount: 1 },
  { idusers: 7, name: "Burak", surname: "Şahin", email: "burak@example.com", role: 2, phoneNo: "0536 222 33 44", isActive: 1, tenants_idtenants: 1, adminId: 1, cardCount: 1 },
  { idusers: 8, name: "Elif", surname: "Yıldız", email: "elif@example.com", role: 2, phoneNo: "0537 555 66 77", isActive: 1, tenants_idtenants: 2, adminId: 0, cardCount: 1 },
];

// --- HELPERS ---

const formatCurrency = (kurus) => {
  return (kurus / 100).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " \u20BA";
};

const formatDate = (epoch) => {
  return new Date(epoch * 1000).toLocaleString("tr-TR");
};

// --- SUMMARY STATS ---

const totalBalance = tempCards.reduce((sum, c) => sum + c.balance, 0);
const activeCards = tempCards.filter((c) => c.isActive === 1).length;
const totalCards = tempCards.length;
const todayTransactions = tempTransactions.filter((t) => t.transactionType === 1);
const todaySalesTotal = todayTransactions.reduce((sum, t) => sum + t.amount, 0);
const todayRefillTotal = tempTransactions.filter((t) => t.transactionType === 2).reduce((sum, t) => sum + t.amount, 0);

// --- STAT CARD COMPONENT ---

function SummaryCard({ icon, title, value, subtitle, color, trend }) {
  return (
    <Card variant="outlined" sx={{ height: "100%", position: "relative", overflow: "visible" }}>
      <CardContent sx={{ p: 2.5 }}>
        <Stack direction="row" spacing={2} alignItems="flex-start">
          <Avatar
            sx={{
              bgcolor: alpha(color, 0.12),
              color: color,
              width: 48,
              height: 48,
            }}
          >
            {icon}
          </Avatar>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="body2" color="text.secondary" noWrap>
              {title}
            </Typography>
            <Typography variant="h5" fontWeight={700} sx={{ mt: 0.5 }}>
              {value}
            </Typography>
            {subtitle && (
              <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mt: 0.5 }}>
                {trend === "up" && <TrendingUpIcon sx={{ fontSize: 16, color: "success.main" }} />}
                {trend === "down" && <TrendingDownIcon sx={{ fontSize: 16, color: "error.main" }} />}
                <Typography variant="caption" color="text.secondary">
                  {subtitle}
                </Typography>
              </Stack>
            )}
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}

// --- BALANCE LOAD DIALOG ---

function LoadBalanceDialog({ open, onClose, cards, onSuccess }) {
  const [selectedCard, setSelectedCard] = useState("");
  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");

  const quickAmounts = [1000, 2500, 5000, 10000, 25000, 50000];

  const handleSubmit = () => {
    if (!selectedCard) { setError("Lütfen bir kart seçin"); return; }
    if (!amount || Number(amount) <= 0) { setError("Geçerli bir tutar girin"); return; }
    onSuccess(selectedCard, Number(amount));
    setSelectedCard("");
    setAmount("");
    setError("");
    onClose();
  };

  const handleClose = () => {
    setSelectedCard("");
    setAmount("");
    setError("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <AddCardIcon color="primary" />
        Bakiye Yükle
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5, mt: 1 }}>
          {error && <Alert severity="error" onClose={() => setError("")}>{error}</Alert>}

          <FormControl fullWidth>
            <InputLabel>Kart Seçin</InputLabel>
            <Select
              value={selectedCard}
              onChange={(e) => setSelectedCard(e.target.value)}
              label="Kart Seçin"
            >
              {cards.filter((c) => c.isActive === 1).map((card) => (
                <MenuItem key={card.idcards} value={card.idcards}>
                  <Stack direction="row" justifyContent="space-between" width="100%" alignItems="center">
                    <Box>
                      <Typography variant="body2" fontWeight={600}>{card.cardOwner}</Typography>
                      <Typography variant="caption" color="text.secondary">{card.cardNo}</Typography>
                    </Box>
                    <Chip label={formatCurrency(card.balance)} size="small" color="primary" variant="outlined" />
                  </Stack>
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            label="Yüklenecek Tutar (kuruş)"
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            fullWidth
            InputProps={{
              endAdornment: <InputAdornment position="end">{amount ? formatCurrency(Number(amount)) : ""}</InputAdornment>,
            }}
            helperText="Kuruş cinsinden girin. Örn: 5000 = 50,00 TL"
          />

          <Box>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: "block" }}>
              Hızlı Tutar Seçimi
            </Typography>
            <Stack direction="row" flexWrap="wrap" gap={1}>
              {quickAmounts.map((qa) => (
                <Chip
                  key={qa}
                  label={formatCurrency(qa)}
                  onClick={() => setAmount(String(qa))}
                  variant={Number(amount) === qa ? "filled" : "outlined"}
                  color={Number(amount) === qa ? "primary" : "default"}
                  sx={{ cursor: "pointer" }}
                />
              ))}
            </Stack>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose}>İptal</Button>
        <Button onClick={handleSubmit} variant="contained" startIcon={<AddCardIcon />}>
          Yükle
        </Button>
      </DialogActions>
    </Dialog>
  );
}

// --- ADD CARD DIALOG ---

function AddCardDialog({ open, onClose, users, onSuccess }) {
  const [formData, setFormData] = useState({ cardNo: "", cardOwner: "", users_idusers: "", periodicRefill: 0, refillAmount: "", refillDayOfMont: 1 });
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (!formData.cardNo || !formData.cardOwner) { setError("Kart no ve kart sahibi zorunludur"); return; }
    onSuccess(formData);
    setFormData({ cardNo: "", cardOwner: "", users_idusers: "", periodicRefill: 0, refillAmount: "", refillDayOfMont: 1 });
    setError("");
    onClose();
  };

  const handleClose = () => {
    setFormData({ cardNo: "", cardOwner: "", users_idusers: "", periodicRefill: 0, refillAmount: "", refillDayOfMont: 1 });
    setError("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <CreditCardIcon color="primary" />
        Yeni Kart Ekle
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          {error && <Alert severity="error" onClose={() => setError("")}>{error}</Alert>}

          <TextField
            label="Kart No"
            value={formData.cardNo}
            onChange={(e) => setFormData({ ...formData, cardNo: e.target.value })}
            fullWidth
            placeholder="CARD-XXXX"
          />

          <TextField
            label="Kart Sahibi"
            value={formData.cardOwner}
            onChange={(e) => setFormData({ ...formData, cardOwner: e.target.value })}
            fullWidth
          />

          <FormControl fullWidth>
            <InputLabel>Kullanıcı</InputLabel>
            <Select
              value={formData.users_idusers}
              onChange={(e) => setFormData({ ...formData, users_idusers: e.target.value })}
              label="Kullanıcı"
            >
              {users.filter((u) => u.isActive === 1).map((user) => (
                <MenuItem key={user.idusers} value={user.idusers}>
                  {user.name} {user.surname} ({user.email})
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Divider sx={{ my: 1 }} />

          <FormControl fullWidth>
            <InputLabel>Otomatik Yükleme</InputLabel>
            <Select
              value={formData.periodicRefill}
              onChange={(e) => setFormData({ ...formData, periodicRefill: e.target.value })}
              label="Otomatik Yükleme"
            >
              <MenuItem value={0}>Kapalı</MenuItem>
              <MenuItem value={1}>Açık</MenuItem>
            </Select>
          </FormControl>

          {formData.periodicRefill === 1 && (
            <>
              <TextField
                label="Yükleme Tutarı (kuruş)"
                type="number"
                value={formData.refillAmount}
                onChange={(e) => setFormData({ ...formData, refillAmount: e.target.value })}
                fullWidth
              />
              <FormControl fullWidth>
                <InputLabel>Yükleme Günü</InputLabel>
                <Select
                  value={formData.refillDayOfMont}
                  onChange={(e) => setFormData({ ...formData, refillDayOfMont: e.target.value })}
                  label="Yükleme Günü"
                >
                  {Array.from({ length: 28 }, (_, i) => i + 1).map((day) => (
                    <MenuItem key={day} value={day}>Her ayın {day}. günü</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose}>İptal</Button>
        <Button onClick={handleSubmit} variant="contained" startIcon={<AddIcon />}>
          Ekle
        </Button>
      </DialogActions>
    </Dialog>
  );
}

// --- MAIN COMPONENT ---

export default function DigitalWallet(props) {
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [loadDialogOpen, setLoadDialogOpen] = useState(false);
  const [addCardDialogOpen, setAddCardDialogOpen] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  // --- COLUMNS ---

  const cellBox = { display: "flex", alignItems: "center", width: "100%", height: "100%" };

  const cardsColumns = [
    {
      field: "cardOwner",
      headerName: "Kart Sahibi",
      flex: 1.2,
      minWidth: 180,
      renderCell: (params) => (
        <Box sx={cellBox}>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Avatar sx={{ width: 32, height: 32, fontSize: 14, bgcolor: "primary.main" }}>
              {params.value?.charAt(0)}
            </Avatar>
            <Box sx={{ lineHeight: 0 }}>
              <Typography variant="body2" fontWeight={600} sx={{ fontSize: 13, lineHeight: 1.2 }}>{params.value}</Typography>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: 11, lineHeight: 1.2 }}>{params.row.cardNo}</Typography>
            </Box>
          </Stack>
        </Box>
      ),
    },
    {
      field: "balance",
      headerName: "Bakiye",
      flex: 1,
      minWidth: 140,
      renderCell: (params) => {
        const val = params.value;
        return (
          <Box sx={{ ...cellBox, flexDirection: "column", justifyContent: "center", alignItems: "flex-start" }}>
            <Typography variant="body2" fontWeight={700} lineHeight={1.3} color={val > 5000 ? "success.main" : val > 0 ? "warning.main" : "error.main"}>
              {formatCurrency(val)}
            </Typography>
            <LinearProgress
              variant="determinate"
              value={Math.min((val / 50000) * 100, 100)}
              sx={{ mt: 0.5, height: 4, borderRadius: 2, width: "80%" }}
              color={val > 5000 ? "success" : val > 0 ? "warning" : "error"}
            />
          </Box>
        );
      },
    },
    {
      field: "isActive",
      headerName: "Durum",
      width: 110,
      renderCell: (params) => (
        <Box sx={cellBox}>
          <Chip
            icon={params.value === 1 ? <CheckCircleIcon /> : <BlockIcon />}
            label={params.value === 1 ? "Aktif" : "Pasif"}
            color={params.value === 1 ? "success" : "default"}
            size="small"
            variant="outlined"
          />
        </Box>
      ),
    },
    {
      field: "periodicRefill",
      headerName: "Oto. Yükleme",
      width: 140,
      renderCell: (params) => (
        <Box sx={cellBox}>
          {params.value !== 1
            ? <Typography variant="caption" color="text.secondary">-</Typography>
            : <Chip label={`${formatCurrency(params.row.refillAmount)} / Ay ${params.row.refillDayOfMont}`} color="info" size="small" variant="outlined" />
          }
        </Box>
      ),
    },
    {
      field: "actions",
      headerName: "İşlemler",
      width: 160,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Box sx={cellBox}>
          <Stack direction="row" spacing={0.5}>
            <Tooltip title="Bakiye Yükle">
              <IconButton size="small" color="primary" onClick={() => setLoadDialogOpen(true)}>
                <AddCardIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Düzenle">
              <IconButton size="small" onClick={() => setSnackbar({ open: true, message: "Düzenleme (demo)", severity: "info" })}>
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title={params.row.isActive === 1 ? "Pasife Al" : "Aktif Et"}>
              <IconButton size="small" color={params.row.isActive === 1 ? "warning" : "success"} onClick={() => setSnackbar({ open: true, message: "Durum değiştirildi (demo)", severity: "info" })}>
                {params.row.isActive === 1 ? <BlockIcon fontSize="small" /> : <CheckCircleIcon fontSize="small" />}
              </IconButton>
            </Tooltip>
            <Tooltip title="Sil">
              <IconButton size="small" color="error" onClick={() => setSnackbar({ open: true, message: "Silme (demo)", severity: "warning" })}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Stack>
        </Box>
      ),
    },
  ];

  const transactionsColumns = [
    { field: "transactionId", headerName: "İşlem No", flex: 1, minWidth: 180 },
    {
      field: "cardOwner",
      headerName: "Kart Sahibi",
      flex: 1,
      minWidth: 160,
      renderCell: (params) => (
        <Box sx={{ ...cellBox, flexDirection: "column", justifyContent: "center", alignItems: "flex-start" }}>
          <Typography variant="body2" sx={{ fontSize: 13, lineHeight: 1.2 }}>{params.value}</Typography>
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: 11, lineHeight: 1.2 }}>{params.row.cardNo}</Typography>
        </Box>
      ),
    },
    {
      field: "epoch",
      headerName: "Tarih",
      flex: 1,
      minWidth: 170,
      renderCell: (params) => (
        <Box sx={cellBox}>
          <Typography variant="body2">{formatDate(params.value)}</Typography>
        </Box>
      ),
    },
    {
      field: "amount",
      headerName: "Tutar",
      width: 130,
      renderCell: (params) => (
        <Box sx={cellBox}>
          <Typography variant="body2" fontWeight={600} color={params.row.transactionType === 2 ? "success.main" : "text.primary"}>
            {params.row.transactionType === 2 ? "+" : "-"}{formatCurrency(params.value)}
          </Typography>
        </Box>
      ),
    },
    {
      field: "productName",
      headerName: "Ürün",
      flex: 0.8,
      minWidth: 130,
    },
    {
      field: "transactionType",
      headerName: "Tür",
      width: 130,
      renderCell: (params) => (
        <Box sx={cellBox}>
          <Chip
            icon={params.value === 1 ? <PointOfSaleIcon /> : <AddCardIcon />}
            label={params.value === 1 ? "Satış" : "Yükleme"}
            color={params.value === 1 ? "warning" : "success"}
            size="small"
            variant="outlined"
          />
        </Box>
      ),
    },
  ];

  const usersColumns = [
    {
      field: "name",
      headerName: "Ad Soyad",
      flex: 1.2,
      minWidth: 180,
      renderCell: (params) => (
        <Box sx={cellBox}>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Avatar sx={{ width: 32, height: 32, fontSize: 14, bgcolor: "secondary.main" }}>
              {params.value?.charAt(0)}
            </Avatar>
            <Box sx={{ lineHeight: 0 }}>
              <Typography variant="body2" fontWeight={600} sx={{ fontSize: 13, lineHeight: 1.2 }}>{params.value} {params.row.surname}</Typography>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: 11, lineHeight: 1.2 }}>{params.row.email}</Typography>
            </Box>
          </Stack>
        </Box>
      ),
    },
    { field: "phoneNo", headerName: "Telefon", flex: 1, minWidth: 150 },
    {
      field: "role",
      headerName: "Rol",
      width: 120,
      renderCell: (params) => (
        <Box sx={cellBox}>
          <Chip
            label={params.value === 1 ? "Admin" : "Kullanıcı"}
            color={params.value === 1 ? "primary" : "default"}
            size="small"
          />
        </Box>
      ),
    },
    {
      field: "cardCount",
      headerName: "Kart Sayısı",
      width: 110,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "isActive",
      headerName: "Durum",
      width: 110,
      renderCell: (params) => (
        <Box sx={cellBox}>
          <Chip
            icon={params.value === 1 ? <CheckCircleIcon /> : <BlockIcon />}
            label={params.value === 1 ? "Aktif" : "Pasif"}
            color={params.value === 1 ? "success" : "default"}
            size="small"
            variant="outlined"
          />
        </Box>
      ),
    },
    {
      field: "actions",
      headerName: "İşlemler",
      width: 110,
      sortable: false,
      filterable: false,
      renderCell: () => (
        <Box sx={cellBox}>
          <Stack direction="row" spacing={0.5}>
            <Tooltip title="Düzenle">
              <IconButton size="small">
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Sil">
              <IconButton size="small" color="error">
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Stack>
        </Box>
      ),
    },
  ];

  // --- TAB CONFIG ---

  const TAB_CONFIG = [
    { label: "Kartlar", icon: <CreditCardIcon />, columns: cardsColumns, rows: tempCards, idField: "idcards" },
    { label: "İşlemler", icon: <ReceiptLongIcon />, columns: transactionsColumns, rows: tempTransactions, idField: "idtransactions" },
    { label: "Kullanıcılar", icon: <PeopleIcon />, columns: usersColumns, rows: tempUsers, idField: "idusers" },
  ];

  const currentTab = TAB_CONFIG[tabIndex];

  // Filter rows by search
  const filteredRows = currentTab.rows.filter((row) => {
    if (!searchText) return true;
    const search = searchText.toLowerCase();
    return Object.values(row).some(
      (val) => val !== null && val !== undefined && String(val).toLowerCase().includes(search)
    );
  });

  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: "flex" }}>
        <SideMenu />
        <AppNavbar />
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: "auto",
          })}
        >
          <PageErrorBoundary>
            <Stack
              spacing={2}
              sx={{
                mx: 3,
                pb: 5,
                mt: { xs: 8, md: 0 },
              }}
            >
              {/* HEADER */}
              <Stack
                direction="row"
                sx={{
                  display: { xs: "none", md: "flex" },
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "space-between",
                  maxWidth: { sm: "100%", md: "1700px" },
                  pt: 1.5,
                }}
              >
                <Typography component="h2" variant="h6" fontWeight={700}>
                  {t("menu.digitalWallet")}
                </Typography>
                <Stack direction="row" spacing={1}>
                  <Button
                    variant="contained"
                    startIcon={<AddCardIcon />}
                    onClick={() => setLoadDialogOpen(true)}
                    size="small"
                  >
                    Bakiye Yükle
                  </Button>
                  <Button
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={() => setAddCardDialogOpen(true)}
                    size="small"
                  >
                    Yeni Kart
                  </Button>
                </Stack>
              </Stack>

              {/* SUMMARY CARDS */}
              <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
                <Grid container spacing={2} columns={12}>
                  <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                    <SummaryCard
                      icon={<CreditCardIcon />}
                      title="Toplam Kart"
                      value={`${totalCards}`}
                      subtitle={`${activeCards} aktif, ${totalCards - activeCards} pasif`}
                      color="#1976d2"
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                    <SummaryCard
                      icon={<AccountBalanceWalletIcon />}
                      title="Toplam Bakiye"
                      value={formatCurrency(totalBalance)}
                      subtitle="Tüm kartların toplamı"
                      color="#2e7d32"
                      trend="up"
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                    <SummaryCard
                      icon={<PointOfSaleIcon />}
                      title="Bugün Satış"
                      value={formatCurrency(todaySalesTotal)}
                      subtitle={`${todayTransactions.length} işlem`}
                      color="#ed6c02"
                      trend="up"
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                    <SummaryCard
                      icon={<CreditScoreIcon />}
                      title="Bugün Yükleme"
                      value={formatCurrency(todayRefillTotal)}
                      subtitle={`${tempTransactions.filter((t) => t.transactionType === 2).length} yükleme`}
                      color="#9c27b0"
                      trend="up"
                    />
                  </Grid>
                </Grid>
              </Box>

              {/* TABS + DATAGRID */}
              <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
                <Card variant="outlined">
                  <Box sx={{ borderBottom: 1, borderColor: "divider", px: 2, pt: 1 }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                      <Tabs
                        value={tabIndex}
                        onChange={(_, v) => { setTabIndex(v); setSearchText(""); }}
                      >
                        {TAB_CONFIG.map((tab, index) => (
                          <Tab
                            key={index}
                            icon={tab.icon}
                            label={tab.label}
                            iconPosition="start"
                            sx={{ minHeight: 48, textTransform: "none" }}
                          />
                        ))}
                      </Tabs>

                      <Stack direction="row" spacing={1} alignItems="center">
                        <TextField
                          size="small"
                          placeholder="Ara..."
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon fontSize="small" />
                              </InputAdornment>
                            ),
                          }}
                          sx={{ width: 220 }}
                        />
                        <Tooltip title="Yenile">
                          <IconButton size="small" onClick={() => setSnackbar({ open: true, message: "Veriler yenilendi (demo)", severity: "success" })}>
                            <RefreshIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Excel İndir">
                          <IconButton size="small" onClick={() => setSnackbar({ open: true, message: "Excel indirildi (demo)", severity: "success" })}>
                            <FileDownloadIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        {tabIndex === 2 && (
                          <Button size="small" startIcon={<PersonAddIcon />} variant="outlined" onClick={() => setSnackbar({ open: true, message: "Kullanıcı ekleme (demo)", severity: "info" })}>
                            Ekle
                          </Button>
                        )}
                      </Stack>
                    </Stack>
                  </Box>

                  <DataGrid
                    rows={filteredRows}
                    columns={currentTab.columns}
                    getRowId={(row) => row[currentTab.idField]}
                    pageSizeOptions={[5, 10, 25]}
                    initialState={{
                      pagination: { paginationModel: { pageSize: 10 } },
                    }}
                    disableRowSelectionOnClick
                    autoHeight
                    rowHeight={tabIndex === 1 ? 52 : 64}
                    sx={{
                      border: "none",
                      "& .MuiDataGrid-cell": { py: 1 },
                    }}
                  />
                </Card>
              </Box>
            </Stack>
          </PageErrorBoundary>
        </Box>
      </Box>

      {/* DIALOGS */}
      <LoadBalanceDialog
        open={loadDialogOpen}
        onClose={() => setLoadDialogOpen(false)}
        cards={tempCards}
        onSuccess={(cardId, amount) => {
          setSnackbar({ open: true, message: `Karta ${formatCurrency(amount)} yüklendi (demo)`, severity: "success" });
        }}
      />

      <AddCardDialog
        open={addCardDialogOpen}
        onClose={() => setAddCardDialogOpen(false)}
        users={tempUsers}
        onSuccess={(data) => {
          setSnackbar({ open: true, message: `${data.cardNo} kartı eklendi (demo)`, severity: "success" });
        }}
      />

      {/* SNACKBAR */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })} variant="filled">
          {snackbar.message}
        </Alert>
      </Snackbar>
    </AppTheme>
  );
}
